<div class="search-component">
    <div class="table-container">
        <h4>
            Endorsements
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button (click)="upsertEndorsement(0)">
                        Add <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getEndorsements(paging)">
                    <button class="search-button" (click)="getEndorsements(paging)">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="endorsements"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getEndorsements($event)"
            [showEdit]="true"
            (editItem)="upsertEndorsement($event)"
            [showDelete]="true"
            (deleteItem)="deleteEndorsement($event)">
        </pageable-table>
    </div>
</div>